import { makeStyles, Text } from '@rneui/themed'
import { Image } from 'expo-image'
import React from 'react'
import { View } from 'react-native'

interface Props {
  distance?: string
}

export function ShiftDistanceView(props: Props) {
  const styles = useStyles()

  return (
    <View style={styles.container}>
      <Image
        source={require('assets/open_shifts/map-icon.png')}
        style={styles.mapIcon}
      />
      {props.distance ? (
        <Text style={styles.distance}>{props.distance}</Text>
      ) : null}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    minWidth: 32,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
  },
  distance: {
    fontSize: 14,
    color: theme.colors?.grey1,
    textAlign: 'center',
    marginTop: 5,
  },
  mapIcon: {
    width: 16.5,
    height: 18.5,
  },
}))
